
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getUpdateMeetingAgendaItemDtoFormGroup() {
return new FormGroup({
    sortableRank: new FormControl<number | undefined>(undefined),
    title: new FormControl<string | undefined>('', [Validators.maxLength(255)]),
    description: new FormControl<string | undefined>(''),
    protocolNotes: new FormControl<string | undefined>(''),
    duration: new FormControl<number | undefined>(undefined),
})
;
}
      